import React, { useContext, useState, useEffect } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { selectData } from 'layouts/onboarding'

import {
  Card,
  Grid,
  Typography,
  Collapse,
  Tooltip,
  Fade,
  IconButton,
} from '@mui/material'
import { ExpandMore, Help } from '@mui/icons-material'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const dollarCentsFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function Other({
  collapseSections,
  toggleCollapse,
  valueOfInvestableAssets,
  fegliTotal,
  optionC,
  adjustedNetTakeHomeInRetirement,
  adjustedWorkingNetTakeHome,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const [localForm, setLocalForm] = useState({
    savingsGoal: intakeState.savingsGoal || '',
    riskScore: intakeState.riskScore || '',
    lifestyleGoal: intakeState?.retirementLifestyleGoal?.lifestyleGoal || '',
    retirementLifestyle:
      intakeState?.retirementLifestyleGoal?.retirementLifestyle || '',
    preferredAppointmentType: intakeState?.preferredAppointmentType || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const onBlur = () => {
    updateIntakeStateAndSubmit(() =>
      updateIntakeStateAtKey({
        retirementLifestyleGoal: {
          lifestyleGoal: localForm.lifestyleGoal,
          retirementLifestyle: localForm.retirementLifestyle,
        },
      })
    )()
  }
  const minimumRetirement =
    adjustedNetTakeHomeInRetirement / adjustedWorkingNetTakeHome
  const splitTheGap = (minimumRetirement + 1) / 2
  const healthInsurance = intakeState?.healthInsurance
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.personal}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="other"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('personal')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Other
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.personal
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.personal} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} sm={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'giftCard',
                  label: 'Preferred Gift Card',
                  placeholder: 'Preferred Gift Card',
                  inputType: 'select',
                  value: intakeState.giftCard,
                  onChange: updateIntakeStateAndSubmit((giftCard) =>
                    updateIntakeStateAtKey({ giftCard })
                  ),
                  options: selectData.giftCards,
                })}
              </Grid>
              <Grid item xs={12} sm={8}></Grid>
              {healthInsurance === 'fehb' && (
                <Grid item xs={12} sm={4}>
                  {renderMuiFormField({
                    autoFocus: false,
                    id: 'fehbFivePlus',
                    label: 'Have you had FEHB for 5+ years?',
                    placeholder: '',
                    inputType: 'select',
                    value: intakeState.fehbFivePlus,
                    onChange: updateIntakeStateAndSubmit((fehbFivePlus) =>
                      updateIntakeStateAtKey({ fehbFivePlus })
                    ),
                    options: selectData.yesNo,
                  })}
                </Grid>
              )}
              <Grid item xs={12} sm={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'fegliExtraABL',
                  label: 'Have you Opted OUT of Automatic Basic Life?',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: intakeState.fegliExtraABL,
                  onChange: updateIntakeStateAndSubmit((fegliExtraABL) =>
                    updateIntakeStateAtKey({ fegliExtraABL })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'totalInvestableAssets',
                  label: 'Total Investable Assets',
                  placeholder: '$200,000.00',
                  inputType: 'currencyFloat',
                  value: intakeState.totalInvestableAssets,
                  onChange: updateIntakeStateAndSubmit(
                    (totalInvestableAssets) =>
                      updateIntakeStateAtKey({ totalInvestableAssets })
                  ),
                })}
                <Typography variant="inputNote" component="p">
                  Uploaded Investable Assets:{' '}
                  {dollarFormat.format(valueOfInvestableAssets)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'savingsGoal',
                  label: 'Savings Goal',
                  placeholder: '$5,000.00',
                  inputType: 'currencyFloat',
                  value: localForm.savingsGoal,
                  onChange: (e) => handleChange('savingsGoal')(e),
                  onBlur: updateIntakeStateAndSubmit((savingsGoal) =>
                    updateIntakeStateAtKey({ savingsGoal })
                  ),
                })}
                <Typography variant="inputNote" component="p">
                  Suggested Goal:
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'riskScore',
                  label: 'Risk Score',
                  placeholder: '75.0',
                  inputType: 'floatField',
                  value: localForm.riskScore,
                  onChange: (e) => handleChange('riskScore')(e),
                  onBlur: updateIntakeStateAndSubmit((riskScore) =>
                    updateIntakeStateAtKey({ riskScore })
                  ),
                })}
              </Grid>
              <Grid item xs={12} sm={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'hasWill',
                  label: 'Client Has A Will?',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: intakeState.hasWill,
                  onChange: updateIntakeStateAndSubmit((hasWill) =>
                    updateIntakeStateAtKey({ hasWill })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              <Grid item xs={12} sm={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'hasTrust',
                  label: 'Client Has a Trust?',
                  placeholder: 'Select',
                  inputType: 'select',
                  value: intakeState.hasTrust,
                  onChange: updateIntakeStateAndSubmit((hasTrust) =>
                    updateIntakeStateAtKey({ hasTrust })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'accountStatus',
                  label: 'Account Status',
                  placeholder: 'Account Status',
                  inputType: 'select',
                  value: intakeState.accountStatus,
                  onChange: updateIntakeStateAndSubmit((accountStatus) =>
                    updateIntakeStateAtKey({ accountStatus })
                  ),
                  options: selectData.accountStatus,
                })}
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {renderMuiFormField({
                  id: 'parcoScore',
                  label: (
                    <>
                      <span>
                        PARCO Score
                        <Tooltip
                          TransitionComponent={Fade}
                          title="Score using the 4% rule with retirement savings"
                          placement="top"
                          color="info"
                        >
                          <IconButton size="small" color="dark">
                            <Help sx={{ marginTop: '-10px' }} />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </>
                  ),
                  placeholder: 'PARCO Score',
                  inputType: 'text',
                  value: intakeState.parcoScore,
                  onChange: updateIntakeStateAndSubmit((parcoScore) =>
                    updateIntakeStateAtKey({ parcoScore })
                  ),
                })}
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {renderMuiFormField({
                  id: 'retirementIncomeGap',
                  label: 'Income Gap',
                  placeholder: '$2,000.00',
                  inputType: 'currencyFloat',
                  value: intakeState.retirementIncomeGap,
                  onChange: updateIntakeStateAndSubmit((retirementIncomeGap) =>
                    updateIntakeStateAtKey({ retirementIncomeGap })
                  ),
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'test',
                  label: 'Retirement Lifestyle Goal',
                  placeholder: '',
                  inputType: 'select',
                  value: localForm.lifestyleGoal,
                  onChange: (e) => handleChange('lifestyleGoal')(e),
                  onBlur: onBlur,
                  options: [
                    {
                      value: minimumRetirement,
                      label: `${Math.round(
                        minimumRetirement * 100
                      )}% - I want to live off just my pension and social security`,
                    },
                    {
                      value: splitTheGap,
                      label: `${Math.round(
                        splitTheGap * 100
                      )}% - I can live off a bit less than my current income`,
                    },
                    {
                      value: 1,
                      label: '100% - I want to maintain my current lifestyle',
                    },
                  ],
                })}
              </Grid>
              <Grid item xs={12} sm={3}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'preferredAppointmentType',
                  label: 'Preferred Appointment Type',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.preferredAppointmentType,
                  onChange: updateIntakeStateAndSubmit(
                    (preferredAppointmentType) =>
                      updateIntakeStateAtKey({ preferredAppointmentType })
                  ),
                  options: selectData.meetingOptions,
                })}
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Other
